import { Component, OnInit } from '@angular/core';

import { ResponsiveCommon } from '../../responsive.common';

@Component({
	selector: 'app-heartbit-point',
	templateUrl: './heartbit-point.component.html',
	styleUrls: ['./heartbit-point.component.scss']
})
export class HeartbitPointComponent extends ResponsiveCommon implements OnInit {

	constructor() {
		super();
	}

	ngOnInit() {
	}

}
